import { render } from "./CopyShioriModal.vue?vue&type=template&id=5c8a59aa&scoped=true"
import script from "./CopyShioriModal.vue?vue&type=script&lang=js"
export * from "./CopyShioriModal.vue?vue&type=script&lang=js"

import "./CopyShioriModal.vue?vue&type=style&index=0&id=5c8a59aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8a59aa"]])

export default __exports__